export default __webpack_public_path__ + "static/media/gb_logo_loading.64b16b76.gif";